(function () {
  "use strict";

  var SCRIPT_ID = "sapiato-popup-orchestrator";
  var ROOT_ID = "sapiato-popup-replacement";
  var STORAGE_PREFIX = "sapiato_popup_";
  var PREVIEW_PARAMETER = "sapiato_popup_preview";
  var PREVIEW_VERIFY_ENDPOINT =
    "https://analytics.sapiato.com/sapiato-popup-preview/verify";
  var KLAVIYO_FORM_SELECTOR = "form.klaviyo-form";
  var hiddenFallbacks = [];
  var fallbackObserver = null;
  var expiryTimer = null;
  var countdownTimer = null;
  var previewMode = false;
  var browserHashPromise = null;
  var RUNTIME_VERSION = "20260930-reliability";

  function protectPrivateSelection() {
    if (
      !/^\/collections\/sapiato-popup-private-[^/?#]+/.test(
        window.location.pathname
      )
    ) {
      return;
    }
    var robots =
      document.querySelector("meta[name='robots']") ||
      document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex,nofollow,noarchive";
    if (!robots.parentNode) {
      document.head.appendChild(robots);
    }
  }

  protectPrivateSelection();

  function scriptElement() {
    return document.getElementById(SCRIPT_ID);
  }

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    var bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.prototype.map.call(bytes, function (value) {
      return value.toString(16).padStart(2, "0");
    });
    return (
      hex.slice(0, 4).join("") +
      "-" +
      hex.slice(4, 6).join("") +
      "-" +
      hex.slice(6, 8).join("") +
      "-" +
      hex.slice(8, 10).join("") +
      "-" +
      hex.slice(10, 16).join("")
    );
  }

  function browserIdHash() {
    if (browserHashPromise) {
      return browserHashPromise;
    }
    if (
      !window.crypto ||
      !window.crypto.subtle ||
      typeof window.TextEncoder !== "function"
    ) {
      return Promise.reject(new Error("browser_hash_unavailable"));
    }
    var bytes = new TextEncoder().encode(
      "sapiato-popup-browser-v2:" + anonymousId()
    );
    browserHashPromise = window.crypto.subtle
      .digest("SHA-256", bytes)
      .then(function (digest) {
        return Array.prototype.map
          .call(new Uint8Array(digest), function (value) {
            return value.toString(16).padStart(2, "0");
          })
          .join("");
      });
    return browserHashPromise;
  }

  function emit(config, eventName, detail) {
    if (previewMode || !config.analytics_endpoint) {
      return;
    }
    var context = detail || {};
    browserIdHash()
      .then(function (stableBrowserHash) {
        var payload = {
          schema_version: 2,
          event_id: uuid(),
          event_name: eventName,
          occurred_at: new Date().toISOString(),
          experiment_id: context.experiment_id || config.experiment_id,
          variant_id: context.variant_id || "",
          creative_id: context.creative_id || "",
          device: window.matchMedia("(max-width: 767px)").matches
            ? "mobile"
            : "desktop",
          page_path: window.location.pathname,
          offer_code: context.offer_code || "",
          reason: context.reason || (eventName === "popup_impression" ? RUNTIME_VERSION : ""),
          browser_id_hash: stableBrowserHash,
          visitor_day: parisDay()
        };
        return window.fetch(config.analytics_endpoint, {
          method: "POST",
          mode: "cors",
          credentials: "omit",
          keepalive: true,
          referrerPolicy: "no-referrer",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
      })
      .catch(function () {});
  }

  function offerFor(config, variant) {
    return variant && variant.offer ? variant.offer : config.offer || {};
  }

  function giveawayFor(variant) {
    return variant && variant.giveaway ? variant.giveaway : {};
  }

  function giveawayFrequency(variant) {
    var giveaway = giveawayFor(variant);
    if (giveaway.active !== true) { return ""; }
    var days = Number(giveaway.period_days);
    return days === 30 ? "Chaque mois" : days === 7 ? "Chaque semaine" :
      days > 0 ? "Tous les " + days + " jours" : "";
  }

  function desktopPresentation(config, original, isPreview) {
    var variant = Object.assign({}, original);
    var editor = document.getElementById("sapiato-popup-editor-settings");
    var data = editor ? editor.dataset : {};
    var mode = data.desktopLayout || "test";
    var desktop = !window.matchMedia("(max-width: 767px)").matches;
    var layout = "left";
    if (mode === "top" || mode === "left") { layout = mode; }
    else {
      var topWeight = config.desktop_layout_winner === "top" ? 80 :
        config.desktop_layout_winner === "left" ? 20 : 50;
      layout = hash("desktop-layout-v1:" + config.experiment_id + ":" + anonymousId()) % 100 < topWeight ? "top" : "left";
    }
    if (isPreview) {
      var requested = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("sapiato_popup_layout") || data.desktopPreview;
      if (requested === "left" || requested === "top") { layout = requested; }
    }
    variant.desktop_layout = layout;
    variant.creative_id = String(original.creative_id || original.id) +
      (desktop && mode === "test" ? "--dl1-" + layout :
        !desktop && variant.image_variant_id ? "--mi1-" + variant.image_variant_id : "--dl1-excluded");
    return variant;
  }

  function eventDetail(config, variant, reason) {
    var offer = offerFor(config, variant);
    return {
      variant_id: variant ? variant.id : "",
      creative_id: variant ? variant.creative_id : "",
      offer_code: offer.code || "",
      reason: reason || ""
    };
  }

  function trackBaseFormActivity(config) {
    if (!config.analytics_endpoint || !config.base_form_id) {
      return;
    }
    window.addEventListener("klaviyoForms", function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (String(detail.formId || "") !== String(config.base_form_id)) {
        return;
      }
      var eventNames = {
        open: "popup_fallback_opened",
        embedOpen: "popup_fallback_opened",
        submit: "popup_fallback_submitted",
        close: "popup_fallback_closed"
      };
      var eventName = eventNames[String(detail.type || "")];
      if (!eventName) {
        return;
      }
      if (
        (detail.type === "open" || detail.type === "embedOpen") &&
        config.journey_mode === "shopify_only_klaviyo_backend" &&
        (document.getElementById(ROOT_ID) ||
          localStorage.getItem(
            STORAGE_PREFIX +
              "impression_" +
              config.experiment_id +
              "_" +
              parisDay()
          ) === "1")
      ) {
        keepFallbacksHidden();
      }
      emitOncePerBrowserDay(
        config,
        eventName,
        {
          id: "klaviyo",
          creative_id: String(
            detail.formVersionId || config.base_form_version || ""
          )
        },
        "official_klaviyo_form_event"
      );
    });
  }

  function parseDate(value) {
    var parsed = new Date(value);
    return Number.isFinite(parsed.getTime()) ? parsed : null;
  }

  function validHttpsUrl(value, allowedHosts) {
    try {
      var url = new URL(value);
      return (
        url.protocol === "https:" &&
        allowedHosts.some(function (host) {
          return url.hostname === host || url.hostname.endsWith("." + host);
        })
      );
    } catch (error) {
      return false;
    }
  }

  function validateConfig(config, preview) {
    var now = new Date();
    var startsAt = parseDate(config.starts_at);
    var endsAt = parseDate(config.ends_at);
    var variants = Array.isArray(config.variants) ? config.variants : [];
    var copy = config.copy || {};
    var validImages = variants.every(function (variant) {
      return validHttpsUrl(variant.image_url, [
        "cdn.shopify.com",
        "shopifycdn.com"
      ]);
    });
    var validWeights =
      variants.length > 0 &&
      variants.every(function (variant) {
        return Number(variant.weight) > 0;
      });
    var validVariantOffers =
      preview === true ||
      variants.every(function (variant) {
        return !variant.offer ||
          (variant.offer.active !== false && Boolean(variant.offer.code));
      });
    var enabledForContext = preview === true || config.enabled === true;
    var activeWindow =
      preview === true || (now >= startsAt && now < endsAt);
    var validEndpoints =
      preview === true ||
      (validHttpsUrl(config.subscription_intent_endpoint, ["sapiato.com"]) &&
        validHttpsUrl(config.subscription_confirm_endpoint, ["sapiato.com"]));
    return Boolean(
      enabledForContext &&
        ["canary", "live"].indexOf(config.mode) >= 0 &&
        config.base_form_id === "UEndAA" &&
        config.base_form_version === "23370262" &&
        config.list_id === "WgL4sC" &&
        config.klaviyo_public_key === "RtTckV" &&
        Number(config.width) === 780 &&
        Number(config.height) === 600 &&
        startsAt &&
        endsAt &&
        startsAt < endsAt &&
        activeWindow &&
        validImages &&
        validWeights &&
        validVariantOffers &&
        validEndpoints &&
        (!config.offer ||
          preview === true ||
          config.offer.active !== false) &&
        (preview === true ||
          !config.offer ||
          (copy.success_title &&
            copy.success_body &&
            config.shopify_discount_method ===
              "standard_actions_update_cart"))
    );
  }

  function hash(input) {
    var value = 2166136261;
    for (var index = 0; index < input.length; index += 1) {
      value ^= input.charCodeAt(index);
      value = Math.imul(value, 16777619);
    }
    return value >>> 0;
  }

  function anonymousId() {
    var key = STORAGE_PREFIX + "visitor";
    var existing = localStorage.getItem(key);
    if (existing) {
      return existing;
    }
    var created = uuid();
    localStorage.setItem(key, created);
    return created;
  }

  function selectVariant(config) {
    var variants = config.variants;
    var total = variants.reduce(function (sum, variant) {
      return sum + Number(variant.weight);
    }, 0);
    var point = hash(anonymousId() + ":" + config.experiment_id) % total;
    var running = 0;
    for (var index = 0; index < variants.length; index += 1) {
      running += Number(variants[index].weight);
      if (point < running) {
        return variants[index];
      }
    }
    return variants[0];
  }

  function parisDay() {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: "Europe/Paris",
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).format(new Date());
  }

  function emitOncePerBrowserDay(config, eventName, variant, reason) {
    var key =
      STORAGE_PREFIX +
      "event_" +
      config.experiment_id +
      "_" +
      eventName +
      "_" +
      parisDay();
    if (localStorage.getItem(key) === "1") {
      return;
    }
    localStorage.setItem(key, "1");
    emit(config, eventName, eventDetail(config, variant, reason || ""));
  }

  function eligible(config, variant) {
    if (window.Shopify && window.Shopify.designMode) {
      return false;
    }
    if (config.mode === "canary") {
      return (
        config.enabled === true &&
        new URLSearchParams(window.location.search).get(
          "sapiato_popup_canary"
        ) === "1"
      );
    }
    emitOncePerBrowserDay(
      config,
      "popup_eligible_visitor",
      variant,
      "active_experiment"
    );
    var rollout = Math.max(
      0,
      Math.min(100, Number(config.rollout_percent || 0))
    );
    if (rollout <= 0) {
      return false;
    }
    var bucket =
      hash(anonymousId() + ":" + config.experiment_id + ":rollout") % 100;
    if (bucket >= rollout) {
      emitOncePerBrowserDay(
        config,
        "popup_fallback_assigned",
        {
          id: "klaviyo",
          creative_id: String(config.base_form_version || "")
        },
        "bucket_" + bucket
      );
      return false;
    }
    emitOncePerBrowserDay(
      config,
      "popup_rollout_assigned",
      variant,
      "bucket_" + bucket
    );
    var impressionKey =
      STORAGE_PREFIX +
      "impression_" +
      config.experiment_id +
      "_" +
      parisDay();
    if (localStorage.getItem(impressionKey) === "1") {
      keepFallbacksHidden();
      return false;
    }
    var lastClosed = Number(localStorage.getItem(STORAGE_PREFIX + "closed_at") || 0);
    var lastSubmitted = Number(localStorage.getItem(STORAGE_PREFIX + "submitted_at") || 0);
    var frequencyMs =
      Math.max(1, Number(config.frequency_days || 7)) * 86400000;
    var subscriberFrequencyMs =
      Math.max(1, Number(config.subscriber_frequency_days || 365)) * 86400000;
    if (Date.now() - lastClosed < frequencyMs ||
        Date.now() - lastSubmitted < subscriberFrequencyMs) {
      keepFallbacksHidden();
      return false;
    }
    return true;
  }

  function privacyBannerVisible() {
    var banner = document.getElementById("shopify-pc__banner");
    if (!banner) {
      return false;
    }
    var style = window.getComputedStyle(banner);
    var rect = banner.getBoundingClientRect();
    return Boolean(
      style.display !== "none" &&
        style.visibility !== "hidden" &&
        Number(style.opacity || 1) > 0 &&
        rect.width > 0 &&
        rect.height > 0
    );
  }

  function activateAfterPrivacyChoice(config, variant) {
    var endsAt = parseDate(config.ends_at);
    if (!endsAt || Date.now() >= endsAt.getTime()) {
      return;
    }
    if (privacyBannerVisible()) {
      window.setTimeout(function () {
        activateAfterPrivacyChoice(config, variant);
      }, 500);
      return;
    }
    activate(config, variant, variant.image_url, null);
  }

  function preloadImage(url, timeoutMs) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      var timer = window.setTimeout(function () {
        reject(new Error("image_timeout"));
      }, timeoutMs);
      image.onload = function () {
        window.clearTimeout(timer);
        if (image.naturalWidth > 0 && image.naturalHeight > 0) {
          resolve(image);
        } else {
          reject(new Error("image_invalid"));
        }
      };
      image.onerror = function () {
        window.clearTimeout(timer);
        reject(new Error("image_error"));
      };
      image.src = url;
    });
  }

  function popupImageUrl(url, width) {
    try {
      var parsed = new URL(url, window.location.href);
      if (parsed.hostname === "cdn.shopify.com") {
        parsed.searchParams.set("width", String(width));
      }
      return parsed.href;
    } catch (_) { return url; }
  }

  function fallbackOverlay(form) {
    var node = form;
    while (node && node !== document.body) {
      if (window.getComputedStyle(node).position === "fixed") {
        return node;
      }
      node = node.parentElement;
    }
    return null;
  }

  function hideFallbacks() {
    document.querySelectorAll(KLAVIYO_FORM_SELECTOR).forEach(function (form) {
      var overlay = fallbackOverlay(form);
      if (!overlay || overlay.dataset.sapiatoPopupHidden === "true") {
        return;
      }
      hiddenFallbacks.push({
        node: overlay,
        visibility: overlay.style.visibility,
        pointerEvents: overlay.style.pointerEvents,
        ariaHidden: overlay.getAttribute("aria-hidden")
      });
      overlay.dataset.sapiatoPopupHidden = "true";
      overlay.style.setProperty("visibility", "hidden", "important");
      overlay.style.setProperty("pointer-events", "none", "important");
      overlay.setAttribute("aria-hidden", "true");
    });
  }

  function keepFallbacksHidden() {
    [hideFallbacks].forEach(function (callback) {
      callback();
    });
    if (!fallbackObserver) {
      fallbackObserver = new MutationObserver(hideFallbacks);
      fallbackObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "style", "aria-hidden"]
      });
    }
  }

  function restoreFallbacks() {
    hiddenFallbacks.forEach(function (snapshot) {
      snapshot.node.style.visibility = snapshot.visibility;
      snapshot.node.style.pointerEvents = snapshot.pointerEvents;
      delete snapshot.node.dataset.sapiatoPopupHidden;
      if (snapshot.ariaHidden === null) {
        snapshot.node.removeAttribute("aria-hidden");
      } else {
        snapshot.node.setAttribute("aria-hidden", snapshot.ariaHidden);
      }
    });
    hiddenFallbacks = [];
    if (fallbackObserver) {
      fallbackObserver.disconnect();
      fallbackObserver = null;
    }
  }

  function rollback(config, variant, reason) {
    var root = document.getElementById(ROOT_ID);
    if (root) {
      root.remove();
    }
    if (!previewMode) {
      if (
        reason === "visitor_closed" &&
        config.journey_mode === "shopify_primary_klaviyo_recovery"
      ) {
        restoreFallbacks();
      } else if (
        reason === "visitor_closed" ||
        reason === "continue_shopping"
      ) {
        keepFallbacksHidden();
      } else {
        restoreFallbacks();
      }
    }
    document.documentElement.classList.remove("sapiato-popup-active");
    [expiryTimer, countdownTimer].forEach(function (timer) {
      if (timer) {
        window.clearTimeout(timer);
        window.clearInterval(timer);
      }
    });
    expiryTimer = null;
    countdownTimer = null;
    emit(config, "popup_rollback", eventDetail(config, variant, reason));
  }

  function styleElement() {
    var style = document.createElement("style");
    style.textContent =
      "#sapiato-popup-replacement{position:fixed;inset:0;bottom:auto;height:100vh;height:100dvh;z-index:90001;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,.48);padding:10px;box-sizing:border-box;visibility:hidden}" +
      "#sapiato-popup-replacement[data-preview=true]{z-index:2147483646}" +
      "#sapiato-popup-replacement[data-ready=true]{visibility:visible}" +
      "#sapiato-popup-replacement *{box-sizing:border-box}" +
      ".sapiato-popup-shell{position:relative;width:min(880px,100%);height:min(600px,100%);flex-shrink:0;display:grid;grid-template-columns:55% 45%;grid-template-rows:minmax(0,1fr);overflow:hidden;background:#fff;color:#171717;box-shadow:0 24px 70px rgba(0,0,0,.28);font-family:Barlow,Arial,sans-serif}" +
      ".sapiato-popup-content form{margin:0}.sapiato-popup-email{margin:0}.sapiato-popup-conditions{font-size:12px;line-height:1.35;color:#555;margin:10px 0 0}.sapiato-popup-conditions a{color:inherit;text-decoration:underline}" +
      ".sapiato-popup-frequency{font-size:18px;line-height:1.2;margin:-6px 0 14px;color:#171717}" +
      "@media(min-width:768px){.sapiato-popup-shell[data-desktop-layout=top]{width:min(600px,100%);height:min(680px,100%);grid-template-columns:1fr;grid-template-rows:48% 52%}.sapiato-popup-shell[data-desktop-layout=top] .sapiato-popup-content{padding:18px 32px;justify-content:flex-start}.sapiato-popup-shell[data-desktop-layout=top][data-image-state=failed]{grid-template-rows:1fr}}" +
      ".sapiato-popup-media{width:100%;height:100%;min-width:0;min-height:0;object-fit:contain;background:#f5f3f0}" +
      ".sapiato-popup-shell[data-image-state=failed]{grid-template-columns:1fr}" +
      ".sapiato-popup-shell[data-image-state=failed] .sapiato-popup-media{display:none}" +
      ".sapiato-popup-content{display:flex;flex-direction:column;justify-content:center;padding:34px 28px;min-width:0;min-height:0;overflow-y:auto;text-align:center}" +
      ".sapiato-popup-kicker{font-size:12px;letter-spacing:2px;text-transform:uppercase;margin:0 0 12px;color:#666}" +
      ".sapiato-popup-title{font-size:30px;line-height:1.12;margin:0 0 14px;font-weight:500}" +
      ".sapiato-popup-body{font-size:16px;line-height:1.45;margin:0 0 18px;color:#333}" +
      ".sapiato-popup-expiration{font-size:14px;font-weight:600;margin:0 0 5px;color:#7b2d27}" +
      ".sapiato-popup-countdown{font-size:12px;font-weight:500;margin:0 0 14px;color:#7b2d27}" +
      ".sapiato-popup-email{width:100%;min-height:48px;border:1px solid #aaa;padding:12px 14px;font:inherit;border-radius:0}" +
      ".sapiato-popup-submit,.sapiato-popup-success-primary,.sapiato-popup-success-secondary{width:100%;min-height:48px;padding:12px 14px;font:700 15px Barlow,Arial,sans-serif;cursor:pointer;margin-top:10px}" +
      ".sapiato-popup-submit,.sapiato-popup-success-primary{border:0;background:#111;color:#fff}" +
      ".sapiato-popup-success-secondary{border:0;background:transparent;color:#555;min-height:auto;padding:7px 4px 2px;font-size:12px;font-weight:500;text-decoration:underline;text-underline-offset:3px}" +
      ".sapiato-popup-submit:disabled{opacity:.55;cursor:wait}" +
      ".sapiato-popup-close{position:absolute;top:12px;right:12px;width:40px;height:40px;border:0;background:rgba(255,255,255,.92);font-size:26px;line-height:1;cursor:pointer;z-index:2}" +
      ".sapiato-popup-disclosure,.sapiato-popup-status,.sapiato-popup-fallback{font-size:11px;line-height:1.35;margin:12px 0 0;color:#666}" +
      ".sapiato-popup-marketing-prompt{font-size:15px;line-height:1.45;margin:4px 0 14px;color:#333}" +
      ".sapiato-popup-marketing-note{font-size:10px;line-height:1.35;margin:8px 0 0;color:#777;font-style:italic}" +
      ".sapiato-popup-disclosure a{color:inherit;text-decoration:underline}" +
      ".sapiato-popup-status{min-height:16px;color:#7b2d27}.sapiato-popup-status:empty{display:none}" +
      ".sapiato-popup-status[data-kind=success]{color:#236b3a}" +
      ".sapiato-popup-fallback{word-break:break-word}" +
      // Let the form size itself; the photograph fills the remaining mobile space.
      "@media(max-width:767px){.sapiato-popup-shell{display:flex;flex-direction:column;height:min(680px,100%);max-height:100%}.sapiato-popup-shell[data-image-state=failed]{height:auto;min-height:min(240px,100%)}.sapiato-popup-content{flex:0 1 auto;padding:22px 22px 24px;min-height:0;overflow-y:auto;justify-content:flex-start}.sapiato-popup-content>*{flex-shrink:0}.sapiato-popup-title{font-size:24px;margin-bottom:8px}.sapiato-popup-body{font-size:14px;margin-bottom:10px}.sapiato-popup-kicker{display:none}.sapiato-popup-disclosure{margin-top:7px}.sapiato-popup-media{display:block;flex:1 1 0;height:0;object-fit:cover;object-position:center top}}";
    return style;
  }

  function countdownText(config) {
    var endsAt = parseDate(config.ends_at);
    var remaining = endsAt ? endsAt.getTime() - Date.now() : 0;
    if (remaining <= 0) {
      return "Offre expirée";
    }
    var hours = Math.floor(remaining / 3600000);
    var minutes = Math.floor((remaining % 3600000) / 60000);
    return (
      (config.copy.countdown_prefix || "Temps restant :") +
      " " +
      hours +
      " h " +
      String(minutes).padStart(2, "0")
    );
  }

  function addTextElement(parent, tag, className, text) {
    var node = document.createElement(tag);
    node.className = className;
    node.textContent = text || "";
    parent.appendChild(node);
    return node;
  }

  function renderSuccess(
    root,
    config,
    variant,
    isPreview,
    discountResult,
    emailAddress
  ) {
    var copy = config.copy || {};
    var offer = offerFor(config, variant);
    var hasOffer = Boolean(offer.code);
    var percent = Number(offer.percent || 0);
    var giveaway = giveawayFor(variant);
    var hasGiveaway = giveaway.active === true;
    var content = root.querySelector(".sapiato-popup-content");
    content.replaceChildren();

    var title = addTextElement(
      content,
      "h2",
      "sapiato-popup-title",
      hasOffer
        ? "VOS –" + percent + " % SONT ACTIVÉS SUR CETTE SÉLECTION"
        : hasGiveaway
          ? copy.success_giveaway_title || "VOTRE PARTICIPATION EST ENREGISTRÉE"
        : copy.success_no_offer_title
    );
    title.id = ROOT_ID + "-title";
    addTextElement(
      content,
      "p",
      "sapiato-popup-body",
      hasOffer
        ? discountResult && discountResult.manual_fallback === true
          ? copy.success_manual_code_body || copy.success_body
          : copy.success_auto_applied_body || copy.success_body
        : hasGiveaway
          ? copy.success_giveaway_body ||
            "Le tirage sera effectué selon le règlement de l'opération."
          : copy.success_no_offer_body
    );
    var primary = addTextElement(
      content,
      "button",
      "sapiato-popup-success-primary",
      hasOffer
        ? "DÉCOUVRIR LA SÉLECTION –" + percent + " %"
        : hasGiveaway
          ? "CONTINUER MES ACHATS"
        : copy.success_no_offer_primary_cta
    );
    primary.type = "button";
    var secondary = null;
    if (hasOffer) {
      secondary = addTextElement(
        content,
        "button",
        "sapiato-popup-success-secondary",
        copy.success_secondary_cta
      );
      secondary.type = "button";
    }
    if (hasOffer) {
      addTextElement(
        content,
        "p",
        "sapiato-popup-fallback",
        (copy.fallback_code_label || "Votre code") +
          " : " +
          offer.code
      );
    }
    primary.addEventListener("click", function () {
      if (!isPreview) {
        emit(
          config,
          "popup_post_signup_clicked",
          eventDetail(config, variant, "primary")
        );
        emit(
          config,
          config.destination_url
            ? "popup_selection_clicked"
            : "popup_continue_clicked",
          eventDetail(config, variant)
        );
      }
      rollback(config, variant, "continue_shopping");
      if (
        !isPreview &&
        config.destination_url &&
        validHttpsUrl(config.destination_url, ["sapiato.com"])
      ) {
        window.location.assign(config.destination_url);
      }
    });
    if (secondary) {
      secondary.addEventListener("click", function () {
        if (isPreview) {
          return;
        }
        emit(
          config,
          "popup_post_signup_clicked",
          eventDetail(config, variant, "cart")
        );
        emit(config, "popup_cart_clicked", eventDetail(config, variant));
        window.location.assign(
          (window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root
            : "/") + "cart"
        );
      });
    }
    if (!isPreview) {
      emit(
        config,
        "popup_success_displayed",
        eventDetail(config, variant)
      );
    }
    root.dataset.state = "success";
  }

  function subscriptionIntent(config, variant, email, marketingConsent) {
    return browserIdHash().then(function (stableBrowserHash) {
      return window
        .fetch(config.subscription_intent_endpoint, {
          method: "POST",
          mode: "cors",
          credentials: "omit",
          cache: "no-store",
          referrerPolicy: "no-referrer",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(Object.assign({
            email: email,
            experiment_id: config.experiment_id,
            variant_id: variant.id,
            creative_id: variant.creative_id,
            page_path: window.location.pathname,
            browser_id_hash: stableBrowserHash,
            occurred_at: new Date().toISOString()
          }, giveawayFor(variant).active === true ? {
            giveaway_mechanic_id: giveawayFor(variant).mechanic_id,
            giveaway_marketing_consent: marketingConsent === true
          } : {}))
        })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("subscription_intent_http_" + response.status);
          }
          return response.json();
        })
        .then(function (payload) {
          if (
            payload.status !== "ready" ||
            typeof payload.intent_token !== "string"
          ) {
            throw new Error("subscription_intent_invalid");
          }
          return payload;
        });
    });
  }

  function createKlaviyoSubscription(config, email) {
    var payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: "SUBSCRIBED"
                    }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: config.list_id
            }
          }
        }
      }
    };
    return window
      .fetch(
        "https://a.klaviyo.com/client/subscriptions/?company_id=" +
          encodeURIComponent(config.klaviyo_public_key),
        {
          method: "POST",
          mode: "cors",
          credentials: "omit",
          referrerPolicy: "no-referrer",
          headers: {
            "Content-Type": "application/vnd.api+json",
            revision: config.klaviyo_revision
          },
          body: JSON.stringify(payload)
        }
      )
      .then(function (response) {
        if (response.status !== 202) {
          throw new Error("subscription_http_" + response.status);
        }
      });
  }

  function confirmSubscription(config, email, intentToken, attempt, startedAt) {
    var currentAttempt = attempt || 1;
    var started = startedAt || Date.now();
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, 8000);
    function retry(reason) {
      if (currentAttempt >= 12 || Date.now() - started >= 60000) {
        throw new Error(reason);
      }
      return new Promise(function (resolve) {
        window.setTimeout(resolve, Math.min(5000, currentAttempt * 1000));
      }).then(function () {
        return confirmSubscription(config, email, intentToken, currentAttempt + 1, started);
      });
    }
    return window
      .fetch(config.subscription_confirm_endpoint, {
        signal: controller.signal,
        method: "POST",
        mode: "cors",
        credentials: "omit",
        cache: "no-store",
        referrerPolicy: "no-referrer",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email,
          intent_token: intentToken
        })
      })
      .then(function (response) {
        window.clearTimeout(timer);
        if (response.status === 200) {
          return response.json();
        }
        if (response.status === 202) {
          return retry("subscription_confirmation_pending");
        }
        if (response.status === 429 || response.status >= 500) {
          return retry("subscription_confirmation_temporarily_unavailable");
        }
        throw new Error("subscription_confirmation_http_" + response.status);
      }, function () {
        window.clearTimeout(timer);
        return retry("subscription_confirmation_network_unavailable");
      })
      .then(function (payload) {
        if (payload.status !== "confirmed") {
          throw new Error("subscription_not_confirmed");
        }
        return payload;
      });
  }

  function persistAcquisitionAttribution(config, variant) {
    var stored = {
      experiment_id: config.experiment_id,
      variant_id: variant.id,
      creative_id: variant.creative_id,
      offer_code: offerFor(config, variant).code || "",
      acquired_at: new Date().toISOString(),
      expires_at: config.ends_at
    };
    localStorage.setItem(
      STORAGE_PREFIX + "attribution",
      JSON.stringify(stored)
    );
    var root =
      window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : "/";
    return window
      .fetch(root + "cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        cache: "no-store",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          attributes: {
            _sapiato_popup_experiment: stored.experiment_id,
            _sapiato_popup_variant: stored.variant_id,
            _sapiato_popup_creative: stored.creative_id,
            _sapiato_popup_acquired_at: stored.acquired_at
          }
        })
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("shopify_cart_attribution_http_" + response.status);
        }
        emit(
          config,
          "popup_attribution_persisted",
          eventDetail(config, variant, "cart_attributes")
        );
        return true;
      })
      .catch(function (error) {
        emit(
          config,
          "popup_attribution_failed",
          eventDetail(
            config,
            variant,
            String(error && error.message ? error.message : error)
          )
        );
        return false;
      });
  }

  function activateShopifyDiscount(config, variant) {
    var offer = offerFor(config, variant);
    var endsAt = parseDate(config.ends_at);
    if (
      !offer.code ||
      offer.active === false ||
      !endsAt ||
      Date.now() >= endsAt.getTime()
    ) {
      return Promise.reject(new Error("offer_inactive_or_expired"));
    }
    if (
      !window.Shopify ||
      !window.Shopify.actions ||
      typeof window.Shopify.actions.updateCart !== "function"
    ) {
      return Promise.reject(new Error("shopify_standard_actions_unavailable"));
    }
    return window.Shopify.actions
      .updateCart(
        { discountCodes: [offer.code] },
        {
          event: {
            context: "standard-action",
            detail: { source: "sapiato-popup" }
          }
        }
      )
      .then(function (result) {
        var errors = Array.isArray(result.userErrors)
          ? result.userErrors
          : [];
        var codes =
          result.cart && Array.isArray(result.cart.discountCodes)
            ? result.cart.discountCodes
            : [];
        var accepted = codes.find(function (row) {
          return (
            String(row.code || "").toUpperCase() ===
            String(offer.code).toUpperCase()
          );
        });
        if (errors.length > 0 || !accepted) {
          emit(
            config,
            "popup_discount_refused",
            eventDetail(config, variant, "shopify_discount_not_accepted")
          );
          throw new Error("shopify_discount_not_accepted");
        }
        return {
          code: offer.code,
          applicable: accepted.applicable !== false
        };
      });
  }

  function buildPopup(config, variant, imageUrl, isPreview, previewState) {
    var copy = config.copy || {};
    var root = document.createElement("div");
    root.id = ROOT_ID;
    root.setAttribute("role", "dialog");
    root.setAttribute("aria-modal", "true");
    root.setAttribute("aria-labelledby", ROOT_ID + "-title");
    root.dataset.preview = isPreview ? "true" : "false";
    root.dataset.state = previewState || "initial";
    root.dataset.runtimeVersion = RUNTIME_VERSION;
    root.appendChild(styleElement());

    var shell = document.createElement("div");
    shell.className = "sapiato-popup-shell";
    var close = addTextElement(
      shell,
      "button",
      "sapiato-popup-close",
      "×"
    );
    close.type = "button";
    close.setAttribute("aria-label", "Fermer");
    var image = document.createElement("img");
    image.className = "sapiato-popup-media";
    image.alt = variant.image_alt || "";
    image.width = 484;
    image.height = 600;
    image.decoding = "async";
    image.loading = "eager";
    var imageRetried = false;
    image.addEventListener("error", function () {
      if (!imageRetried) {
        imageRetried = true;
        image.src = popupImageUrl(imageUrl, 320);
        return;
      }
      shell.dataset.imageState = "failed";
      image.hidden = true;
      if (!isPreview) {
        emit(
          config,
          "popup_image_failed",
          eventDetail(config, variant, "non_blocking_image_error")
        );
      }
    });
    image.src = popupImageUrl(imageUrl, window.innerWidth < 768 ? 600 : 1000);
    shell.appendChild(image);
    var content = document.createElement("div");
    content.className = "sapiato-popup-content";

    var title = addTextElement(
      content,
      "h2",
      "sapiato-popup-title",
      variant.title
    );
    title.id = ROOT_ID + "-title";
    if (giveawayFrequency(variant)) {
      addTextElement(content, "p", "sapiato-popup-frequency", giveawayFrequency(variant));
    }
    addTextElement(content, "p", "sapiato-popup-body", variant.body);
    var expiration = addTextElement(
      content,
      "p",
      "sapiato-popup-expiration",
      copy.expiration
    );
    var countdown = addTextElement(
      content,
      "p",
      "sapiato-popup-countdown",
      ""
    );
    if (variant.countdown === true) {
      countdown.textContent = isPreview
        ? copy.countdown_prefix + " synchronisé avec Shopify"
        : countdownText(config);
    } else {
      expiration.hidden = true;
      countdown.hidden = true;
    }
    var form = document.createElement("form");
    form.noValidate = true;
    var email = document.createElement("input");
    email.className = "sapiato-popup-email";
    email.type = "email";
    email.name = "email";
    email.autocomplete = "email";
    email.placeholder = copy.input_placeholder || "Votre adresse email";
    email.setAttribute("aria-label", email.placeholder);
    email.required = true;
    var submit = addTextElement(
      form,
      "button",
      "sapiato-popup-submit",
      variant.cta
    );
    submit.type = "submit";
    var giveaway = giveawayFor(variant);
    var disclosure = document.createElement("p");
    disclosure.className = "sapiato-popup-disclosure";
    disclosure.textContent = "Je m’inscris aux emails SAPIATO. Désinscription à tout moment.";
    var conditions = document.createElement("p");
    conditions.className = "sapiato-popup-conditions";
    if (giveaway.active === true) {
      var rulesLink = document.createElement("a");
      rulesLink.href = "https://analytics.sapiato.com/sapiato-giveaway-rules";
      rulesLink.target = "_blank";
      rulesLink.rel = "noopener noreferrer";
      rulesLink.textContent = "Règlement";
      conditions.appendChild(rulesLink);
    }
    var status = document.createElement("p");
    status.className = "sapiato-popup-status";
    status.setAttribute("aria-live", "polite");
    form.append(email, submit);
    if (giveaway.active === true) { form.appendChild(conditions); }
    form.append(disclosure, status);
    content.appendChild(form);
    shell.appendChild(content);
    root.appendChild(shell);

    close.addEventListener("click", function () {
      if (!isPreview) {
        localStorage.setItem(
          STORAGE_PREFIX + "closed_at",
          String(Date.now())
        );
        emit(config, "popup_closed", eventDetail(config, variant));
      }
      rollback(
        config,
        variant,
        isPreview ? "preview_closed" : "visitor_closed"
      );
    });

    var emailStarted = false;
    var pendingSignup = null;
    email.addEventListener("input", function () {
      if (!isPreview && !emailStarted) {
        emailStarted = true;
        emit(config, "popup_email_started", eventDetail(config, variant));
      }
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (submit.disabled) { return; }
      if (isPreview) {
        status.textContent =
          "Prévisualisation privée — aucune inscription ni remise n’est activée.";
        return;
      }
      if (!email.checkValidity()) {
        email.reportValidity();
        return;
      }
      var cleanEmail = email.value.trim().toLowerCase();
      submit.disabled = true;
      email.readOnly = true;
      status.textContent = "Confirmation de votre inscription en cours…";
      root.dataset.state = "loading";
      emit(
        config,
        "popup_email_valid_submitted",
        eventDetail(config, variant)
      );
      var intentPayload;
      var wantsMarketing = true;
      (pendingSignup && pendingSignup.email === cleanEmail
        ? Promise.resolve(pendingSignup.intent)
        : subscriptionIntent(config, variant, cleanEmail, wantsMarketing))
        .then(function (intent) {
          intentPayload = intent;
          if (!pendingSignup || pendingSignup.email !== cleanEmail) {
            pendingSignup = { email: cleanEmail, intent: intent, sent: false };
          }
          if (intent.already_subscribed === true) {
            emit(
              config,
              "popup_subscription_existing",
              eventDetail(config, variant)
            );
            return confirmSubscription(
              config,
              cleanEmail,
              intent.intent_token,
              1
            );
          }
          return (pendingSignup.sent ? Promise.resolve() : createKlaviyoSubscription(config, cleanEmail)).then(
            function () {
              pendingSignup.sent = true;
              return confirmSubscription(
                config,
                cleanEmail,
                intent.intent_token,
                1
              );
            }
          );
        })
        .then(function () {
          if (wantsMarketing && !intentPayload.already_subscribed) {
            emit(
              config,
              "popup_subscription_confirmed",
              eventDetail(config, variant)
            );
          }
          if (giveaway.active === true) {
            emit(
              config,
              "popup_giveaway_entered",
              eventDetail(config, variant, "single_step_marketing_optin")
            );
          }
          if (!offerFor(config, variant).code) {
            return {
              code: "",
              applicable: true,
              no_offer: true
            };
          }
          return activateShopifyDiscount(config, variant).catch(
            function (error) {
              var reason = String(
                error && error.message
                  ? error.message
                  : "shopify_discount_activation_failed"
              );
              emit(
                config,
                "popup_discount_failed",
                eventDetail(config, variant, reason)
              );
              return {
                code: offerFor(config, variant).code,
                applicable: false,
                manual_fallback: true,
                auto_applied: false
              };
            }
          );
        })
        .then(function (discount) {
          return persistAcquisitionAttribution(config, variant).then(
            function () {
              return discount;
            }
          );
        })
        .then(function (discount) {
          localStorage.setItem(
            STORAGE_PREFIX + "submitted_at",
            String(Date.now())
          );
          if (!discount.no_offer && discount.auto_applied !== false) {
            emit(
              config,
              "popup_discount_activated",
              eventDetail(
                config,
                variant,
                discount.applicable
                  ? "applicable"
                  : "accepted_pending_cart_item"
              )
            );
          }
          emit(config, "popup_submitted", eventDetail(config, variant));
          if (giveaway.active === true && discount.no_offer) {
            status.dataset.kind = "success";
            status.textContent =
              copy.giveaway_signup_confirmed ||
              "Inscription et participation confirmées. Bonne chance !";
            root.dataset.state = "success";
            window.setTimeout(function () {
              rollback(config, variant, "single_step_confirmed");
            }, 3000);
            return;
          }
          renderSuccess(
            root,
            config,
            variant,
            false,
            discount,
            cleanEmail
          );
        })
        .catch(function (error) {
          var reason = String(
            error && error.message ? error.message : "journey_failed"
          );
          submit.disabled = false;
          email.readOnly = false;
          var stillPending = reason === "subscription_confirmation_pending";
          status.textContent = stillPending
            ? "La confirmation prend un peu plus de temps. Cliquez pour vérifier à nouveau."
            : (copy.error || "Une erreur est survenue. Merci de réessayer.");
          submit.textContent = stillPending ? "VÉRIFIER MON INSCRIPTION" : variant.cta;
          if (reason === "subscription_confirmation_http_401") { pendingSignup = null; }
          root.dataset.state = "error";
          if (reason.indexOf("shopify_") === 0 || reason.indexOf("offer_") === 0) {
            emit(
              config,
              "popup_discount_failed",
              eventDetail(config, variant, reason)
            );
          } else {
            emit(
              config,
              stillPending ? "popup_subscription_pending" : "popup_subscription_failed",
              eventDetail(config, variant, reason)
            );
          }
        });
    });

    if (isPreview && previewState === "loading") {
      submit.disabled = true;
      status.textContent = copy.loading;
    } else if (isPreview && previewState === "error") {
      status.textContent = copy.error;
      email.setAttribute("aria-invalid", "true");
    } else if (isPreview && previewState === "success") {
      renderSuccess(root, config, variant, true);
    }
    return root;
  }

  function popupDimensionsMatch(rect, viewport, desktopLayout) {
    var top = viewport.width >= 768 && desktopLayout === "top";
    return rect.width >= Math.min(240, viewport.width - 20) &&
      rect.height >= Math.min(200, viewport.height - 20) &&
      rect.width <= Math.min(top ? 600 : 880, viewport.width - 20) + 2 &&
      rect.height <= Math.min(viewport.width < 768 || top ? 680 : 600, viewport.height - 20) + 2 &&
      rect.left >= viewport.left - 2 && rect.top >= viewport.top - 2 &&
      rect.right <= viewport.right + 2 && rect.bottom <= viewport.bottom + 2;
  }

  function activate(config, variant, imageUrl, previewClaims) {
    if (document.getElementById(ROOT_ID)) {
      return;
    }
    var isPreview = Boolean(previewClaims);
    variant = desktopPresentation(config, variant, isPreview);
    var previewState = isPreview
      ? previewClaims.preview_state || "initial"
      : "initial";
    var root = buildPopup(
      config,
      variant,
      imageUrl,
      isPreview,
      previewState
    );
    document.body.appendChild(root);
    var shell = root.querySelector(".sapiato-popup-shell");
    shell.dataset.desktopLayout = variant.desktop_layout;
    var rect = shell.getBoundingClientRect();
    // The fixed overlay excludes the scrollbar; innerWidth includes it.
    // Comparing against innerWidth rejected otherwise valid popups on desktop.
    var viewport = root.getBoundingClientRect();
    var controlsValid =
      previewState === "success"
        ? Boolean(root.querySelector(".sapiato-popup-success-primary"))
        : Boolean(
            root.querySelector("input[type=email]") &&
              root.querySelector("button[type=submit]")
          );
    if (
      !popupDimensionsMatch(rect, viewport, variant.desktop_layout) ||
      !controlsValid
    ) {
      root.remove();
      emit(
        config,
        "popup_blocked",
        eventDetail(config, variant, "runtime_geometry_or_controls_invalid")
      );
      return;
    }
    if (!isPreview) {
      hideFallbacks();
      fallbackObserver = new MutationObserver(hideFallbacks);
      fallbackObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    document.documentElement.classList.add("sapiato-popup-active");
    root.dataset.ready = "true";
    localStorage.setItem(
      STORAGE_PREFIX +
        "impression_" +
        config.experiment_id +
        "_" +
        parisDay(),
      "1"
    );
    if (previewState !== "success") {
      // Keep the dialog in view without opening the mobile keyboard immediately.
      root.tabIndex = -1;
      root.focus({ preventScroll: true });
    }
    emit(config, "popup_impression", eventDetail(config, variant));
    if (!isPreview && variant.countdown === true) {
      countdownTimer = window.setInterval(function () {
        var node = root.querySelector(".sapiato-popup-countdown");
        if (node) {
          node.textContent = countdownText(config);
        }
      }, 30000);
    }
    var expiresAt = isPreview
      ? parseDate(previewClaims.expires_at)
      : parseDate(config.ends_at);
    expiryTimer = window.setTimeout(function () {
      rollback(
        config,
        variant,
        isPreview ? "preview_expired" : "experiment_expired"
      );
    }, Math.max(0, Math.min(2147483647, expiresAt.getTime() - Date.now())));
  }

  function verifyPreviewToken(token) {
    return window
      .fetch(PREVIEW_VERIFY_ENDPOINT, {
        method: "POST",
        mode: "cors",
        credentials: "omit",
        cache: "no-store",
        referrerPolicy: "no-referrer",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token: token })
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("preview_token_http_" + response.status);
        }
        return response.json();
      })
      .then(function (claims) {
        if (
          claims.valid !== true ||
          !claims.experiment_id ||
          !claims.variant_id ||
          ["initial", "loading", "error", "success"].indexOf(
            claims.preview_state
          ) < 0 ||
          !parseDate(claims.expires_at)
        ) {
          throw new Error("preview_claims_invalid");
        }
        return claims;
      });
  }

  function trackCheckout(config) {
    var stored;
    try {
      stored = JSON.parse(
        localStorage.getItem(STORAGE_PREFIX + "attribution") || "null"
      );
    } catch (error) {
      stored = null;
    }
    if (
      !stored ||
      !parseDate(stored.expires_at) ||
      Date.now() >= parseDate(stored.expires_at).getTime()
    ) {
      return;
    }
    var eligibleHandles = Array.isArray(config.eligible_product_handles)
      ? config.eligible_product_handles
      : [];
    var currentHandle = "";
    var productMatch = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    if (productMatch) {
      currentHandle = decodeURIComponent(productMatch[1]);
      emit(
        config,
        eligibleHandles.indexOf(currentHandle) >= 0
          ? "popup_eligible_product_viewed"
          : "popup_ineligible_navigation",
        {
          experiment_id: stored.experiment_id,
          variant_id: stored.variant_id,
          creative_id: stored.creative_id,
          offer_code: stored.offer_code
        }
      );
    } else if (
      config.destination_url &&
      window.location.href.split(/[?#]/)[0] ===
        config.destination_url.split(/[?#]/)[0]
    ) {
      emit(config, "popup_selection_viewed", {
        experiment_id: stored.experiment_id,
        variant_id: stored.variant_id,
        creative_id: stored.creative_id,
        offer_code: stored.offer_code
      });
    }
    document.addEventListener(
      "click",
      function (event) {
        var target = event.target;
        if (!target || typeof target.closest !== "function") {
          return;
        }
        var addToCart = target.closest(
          "button[name='add'],form[action*='/cart/add'] button,[data-add-to-cart]"
        );
        if (
          addToCart &&
          currentHandle &&
          eligibleHandles.indexOf(currentHandle) >= 0
        ) {
          emit(config, "popup_eligible_product_carted", {
            experiment_id: stored.experiment_id,
            variant_id: stored.variant_id,
            creative_id: stored.creative_id,
            offer_code: stored.offer_code
          });
        }
        var link = target.closest("a[href*='/checkout']");
        if (link) {
          emit(config, "popup_checkout_started", {
            experiment_id: stored.experiment_id,
            variant_id: stored.variant_id,
            creative_id: stored.creative_id,
            offer_code: stored.offer_code
          });
        }
      },
      true
    );
  }

  function trackReferenceTraffic(config) {
    if (
      config.reference_measurement_enabled !== true ||
      !config.analytics_endpoint ||
      config.enabled !== false ||
      Number(config.rollout_percent || 0) !== 0 ||
      window.self !== window.top ||
      navigator.webdriver === true ||
      (window.Shopify && window.Shopify.designMode === true) ||
      /bot|crawler|spider|headless|lighthouse|pagespeed|preview|monitor|synthetic/i.test(
        String(navigator.userAgent || "")
      )
    ) {
      return;
    }
    var day = parisDay();
    var key = STORAGE_PREFIX + "reference_" + day;
    if (window.localStorage.getItem(key) === "1") {
      return;
    }
    window.localStorage.setItem(key, "1");
    emit(config, "popup_eligible_visitor", {
      experiment_id:
        config.reference_experiment_id || "popup-reference-traffic-v1",
      variant_id: "base-fallback",
      creative_id: "UEndAA",
      offer_code: ""
    });
  }

  var defaultPopupRequested = false;

  function startDefaultPopup() {
    // The commercial timer may disable or expire an experiment. Acquisition
    // must still work when the old Klaviyo form has been removed.
    if (defaultPopupRequested || new URLSearchParams(
      window.location.hash.replace(/^#/, "")
    ).has(PREVIEW_PARAMETER)) {
      return;
    }
    defaultPopupRequested = true;
    var defaultUrl = new URL("sapiato-popup-default.json", script.src);
    window.fetch(defaultUrl.href, {
      method: "GET", mode: "cors", credentials: "omit", cache: "no-store"
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("default_config_http_" + response.status);
      }
      return response.json();
    }).then(function (config) {
      // A permanent fallback must never revive a coupon or a prize draw.
      if (config.offer || (config.variants || []).some(function (variant) {
        return variant.offer || (variant.giveaway && variant.giveaway.active);
      })) {
        return;
      }
      start(config, true);
    }).catch(function () {});
  }

  function applyEditorSettings(config) {
    var element = document.getElementById("sapiato-popup-editor-settings");
    if (!element || !Array.isArray(config.variants)) { return config; }
    var data = element.dataset;
    config.variants = config.variants.map(function (original) {
      var variant = Object.assign({}, original);
      var giveaway = giveawayFor(variant);
      var curated = config.curated_images || {};
      var pictures = (curated.images || []).filter(function (picture) {
        return (picture.id === "a" || picture.id === "b") && validHttpsUrl(picture.image_url, ["cdn.shopify.com"]);
      });
      if (!data.image && pictures.length === 2 && pictures[0].id !== pictures[1].id) {
        var pictureId = curated.default_image_id || "a";
        if (window.matchMedia("(max-width: 767px)").matches) {
          var bWeight = curated.winner_image === "b" ? 80 : curated.winner_image === "a" ? 20 : 50;
          pictureId = hash("mobile-image-v1:" + curated.test_id + ":" + anonymousId()) % 100 < bWeight ? "b" : "a";
          variant.image_variant_id = pictureId;
        }
        var previewRequested = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("sapiato_popup_image");
        if (new URLSearchParams(window.location.hash.replace(/^#/, "")).has(PREVIEW_PARAMETER) && (previewRequested === "a" || previewRequested === "b")) {
          pictureId = previewRequested;
          variant.image_variant_id = pictureId;
        }
        var picture = pictures.find(function (item) { return item.id === pictureId; }) || pictures[0];
        variant.image_url = picture.image_url;
        variant.image_alt = picture.image_alt;
      }
      var kind = giveaway.active === true ? "giveaway" : "newsletter";
      ["title", "body", "cta"].forEach(function (field) {
        var key = kind + field.charAt(0).toUpperCase() + field.slice(1);
        if (data[key] && data[key].trim()) {
          variant[field] = data[key].trim().replace(/\{montant\}/g, String(giveaway.prize_amount_eur || ""));
        }
      });
      if (data.image) {
        var imageUrl = new URL(data.image, window.location.href);
        if (validHttpsUrl(imageUrl.href, ["cdn.shopify.com", "sapiato.com", "www.sapiato.com"])) {
          variant.image_url = imageUrl.href;
        }
      }
      return variant;
    });
    return config;
  }

  function start(config, isDefault) {
    config = applyEditorSettings(config);
    if (window.Shopify && window.Shopify.designMode === true) {
      var editor = document.getElementById("sapiato-popup-editor-settings");
      var requested = editor ? editor.dataset.preview : "giveaway";
      if (requested === "off") { return; }
      var selected = (config.variants || []).find(function (variant) {
        return (giveawayFor(variant).active === true) === (requested === "giveaway");
      });
      if (selected) {
        previewMode = true;
        activate(config, selected, selected.image_url, {preview_state: "initial", expires_at: new Date(Date.now() + 86400000).toISOString()});
      }
      return;
    }
    var token = new URLSearchParams(
      window.location.hash.replace(/^#/, "")
    ).get(PREVIEW_PARAMETER);
    if (token) {
      verifyPreviewToken(token)
        .then(function (claims) {
          var variants = Array.isArray(config.variants)
            ? config.variants
            : [];
          var variant = variants.find(function (row) {
            return row.id === claims.variant_id;
          });
          if (
            !validateConfig(config, true) ||
            claims.experiment_id !== config.experiment_id ||
            !variant
          ) {
            throw new Error("preview_config_mismatch");
          }
          previewMode = true;
          return preloadImage(
            variant.image_url,
            Number(config.image_timeout_ms || 5000)
          ).then(function () {
            activate(config, variant, variant.image_url, claims);
          });
        })
        .catch(function () {});
      return;
    }
    trackBaseFormActivity(config);
    trackReferenceTraffic(config);
    trackCheckout(config);
    if (!validateConfig(config, false)) {
      if (!isDefault) {
        startDefaultPopup();
      }
      return;
    }
    var variant = selectVariant(config);
    if (!eligible(config, variant)) {
      return;
    }
    if (config.journey_mode === "shopify_only_klaviyo_backend") {
      keepFallbacksHidden();
    }
    window.setTimeout(function () {
      activateAfterPrivacyChoice(config, variant);
    }, Math.max(3000, Number(config.trigger_delay_ms || 0)));
  }

  var script = scriptElement();
  if (!script || !script.dataset.configUrl) {
    return;
  }
  window
    .fetch(script.dataset.configUrl, {
      method: "GET",
      mode: "cors",
      credentials: "omit",
      cache: "no-store"
    })
    .then(function (response) {
      if (!response.ok) {
        throw new Error("config_http_" + response.status);
      }
      return response.json();
    })
    .then(start)
    .catch(startDefaultPopup);
})();
